<script setup>
import Grid from "../../../../../frontend/src/components/Grid.vue";
import useGrid from "@/composables/useGrid";
import {onMounted, ref} from "vue";
import AiPromptEdit from "@/components/aiPrompts/AiPromptEdit.vue";
import aiPromptsService from "@/services/ai-prompts.service";
import AiPromptRun from "@/components/aiPrompts/AiPromptRun.vue";

const {items, gridParams, gridMethods} = useGrid(aiPromptsService.getIndexList);

const columns = [
    {
        label: 'Name',
        name: 'name',
    },
    {
        label: 'Description',
        name: 'description',
    },
    {
        name: 'actions',
        label: 'Actions',
        component: 'Actions',
    },
];

const editPrompt = ref(null);
const runPrompt = ref(null);

onMounted(() => {
    gridMethods.setColumns(columns);
    gridMethods.resetList();
});

function gridAction(params) {
    if (params.action === 'edit') {
        editPrompt.value.open(params.rowId);
    } else if (params.action === 'run') {
        runPrompt.value.open(params.rowId);
    }
}
</script>

<template>
    <div>
        <div class="main-table-wrapper">
            <div class="main-table overflow-auto">
                <Grid
                    :columns="columns"
                    :data="items"
                    :page-length="parseInt(gridParams.pageLength)"
                    :total-rows-count="gridParams.totalRowsCount"
                    :sort="gridParams.sort"
                    :currentPage="gridParams.currentPage"
                    v-on:changePage="gridMethods.changePage"
                    v-on:action="gridAction"
                />
            </div>
        </div>

        <AiPromptEdit
            ref="editPrompt"
            @saved="gridMethods.updateList"
        />

        <AiPromptRun ref="runPrompt"/>
    </div>
</template>

<style scoped>

</style>
